import React from 'react'
import styled from 'styled-components'
import { Result } from 'antd'
import { Link } from 'react-router-dom'

export default function PageError() {
  return (
    <Container>
      <Result
        status='404'
        title='Sorry !!'
        subTitle='The page you visited does not exist.'
        extra={
          <Link to='/'>
            <BtnBack>Back Home</BtnBack>
          </Link>
        }
      />
    </Container>
  )
}

export const Container = styled.div`
  color: var(--black);
  text-align: center;
  background-color: var(--white);
  height: 100%;
  width: 100%;
  padding: 130px 158px 0 158px;

  @media only screen and (max-width: 414px) {
    padding: 130px 50px 0 50px !important;
  }

  @media only screen and (max-width: 912px) {
    padding: 150px 80px 0 80px;
  }
  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    padding: 150px 80px 0 80px !important;
  }
`

export const BtnBack = styled.button`
  color: var(--secondary);
  text-align: center;
  background-color: var(--white);
  height: 100%;
  padding: 4px 20px;
  font-size: 46px;
  font-family: 'Brevia Light Italic';
  cursor: pointer;
  border-radius: 20px;
  border: 1px solid var(--secondary);

  &:hover {
    color: var(--white);
    background-color: var(--secondary);
  }
`
